<template>
  <button @click="onClick" tabindex="-1" :disabled="loading || disabled" :class="className + ' custom_loading_btn'" :type="type">
    <template v-if="!loading">
      <div class="button_title" v-html="title"/>
    </template>
    <template v-else>
      <scale-loader class="loading_spinner" :loading="true" :color="color || 'white'" height="12px"></scale-loader>
    </template>
  </button>
</template>

<script>

export default {
  props: ['title', 'loading', 'disabled', 'className', 'onClick', 'color', 'type'],
  data() {
    return {}
  },
  methods: {
    actionBtn() {
      console.log('no action in btn');
    }
  }
}

</script>
<style scoped>
.loading_spinner {
  min-width: 65px;
}
</style>
<style>
.button_title i {
  text-align: center;
}

i.rotate-up {
  transform: rotate(90deg);
}

i.rotate-down {
  transform: rotate(-90deg);
}

.custom_loading_btn.form-field {
  border-radius: 0;
  height: 38px;
}
</style>
